import React from 'react';

import { Button, Typography } from '@material-ui/core';

import * as Api from '../../../weborder/Api';

interface TipOptionButtonProps {
  active: boolean;
  children: number;
  designScheme: Api.AppDesignScheme;
  onChange(percentage: number);
  translate: any;
}

export const TipOptionButton = (props: TipOptionButtonProps): JSX.Element => {
  const { children, translate } = props;

  const onChange = () => {
    props.onChange(props.children);
  };

  return (
    <button
      aria-label={`${translate('Set_tip_to')} ${children}%`}
      className="fd-button fd-button--big tip-button flex flex-align-center flex-justify-center flex-one"
      key={`tip-button-${children}`}
      onClick={onChange}
    >
      <p>{children}%</p>
    </button>
  );
};

interface Props {
  onChange(percentage: number);
  tipPercentageOptions: number[];
  translate: any;
}

export const TipOptions = (props: Props): JSX.Element => {
  const { onChange, tipPercentageOptions, translate } = props;

  const renderTipOptionButton = (tip: number): JSX.Element => {
    const label = tip.toString();

    return (
      <Button
        aria-label={`${translate('Set_tip_to')} ${label}%`}
        key={`tip-button-${label}`}
        onClick={() => onChange(tip)}
      >
        <Typography>{label}%</Typography>
      </Button>
    );
  };

  return <>{tipPercentageOptions.map((tip) => renderTipOptionButton(tip))}</>;
};
